import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {LeadSummaryFragment} from 'nutshell-graphql-types';

import {DataFieldWrapper} from '../../../core-entity/widgets/summary-widget/data-field-wrapper';

type Props = {
    lead: LeadSummaryFragment | null | undefined;
};

export function LeadOpenedBy(props: Props) {
    if (!props.lead) {
        return null;
    }

    return (
        <DataFieldWrapper
            label='Opened by'
            children={
                <Stack isHorizontal={true} spacing={4} alignItems='center'>
                    <Body truncate={{type: 'inline'}}>{props.lead.creator.name}</Body>
                    {props.lead.clonedFrom && props.lead.clonedFrom.number && (
                        <Body truncate={{type: 'inline'}}>
                            <Link href={props.lead.clonedFrom.htmlUrl}>
                                (Cloned from Lead-{props.lead.clonedFrom.number})
                            </Link>
                        </Body>
                    )}
                </Stack>
            }
        />
    );
}
